//Modules
import { useState, Fragment } from "react";
import Image from "next/image";
import Link from "next/link";
import Layout from "../components/shared/layout/external";
import axios from "axios";

//Context
import { useAuth } from "../lib/hooks/auth";
import { useAlert } from "../lib/hooks/alert";

//Components
import LegacyEmail from "../components/features/legacy/legacyEmail";
import LegacyCode from "../components/features/legacy/legacyCode";
import LegacyPassword from "../components/features/legacy/legacyPassword";

export default function Legacy() {
  //emailSent = flag to change screen to 'code' input
  const [emailSent, setEmailSent] = useState(false);
  //email = saves the users entered email
  const [email, setEmail] = useState(null);
  //otp = saves the otp the server returns
  const [otp, setOtp] = useState(null);
  //recordID = saves the RecordID the of the Method Contact associated
  const [recordID, setRecordID] = useState(null);
  //password = flag to change the screen to 'password' input
  const [password, setPassword] = useState(false);

  //Hooks
  const { legacySignup, loadingAuth, setLoadingAuth } = useAuth();
  const { setAlert } = useAlert();

  async function onEmailSubmit(values) {
    setLoadingAuth(true);

    try {
      //Go search for the account, generates a code and sends an email.
      let result = await axios({
        method: "get",
        url: `/api/legacy?Email=${values.email}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "e7XLA85Z2x1Kgac",
        },
      });
      //Get the code back.
      setEmailSent(true);
      //Save relevant data;
      setEmail(values.email);
      setOtp(result.data.otp);
      setRecordID(result.data.RecordID);
      //Clean up
      setLoadingAuth(false);
    } catch (error) {
      setLoadingAuth(false);
      //Handle error response
      if (error.response.status === 404) {
        setAlert({
          title: "Account Not Found",
          message:
            "No account was found under this email address. Please try again or contact support.",
          type: "error",
        });
      }
      if (error.response.status === 418) {
        setAlert({
          title: "Multiple Accounts Found",
          message:
            "Multiple accounts found under this email address. Please contact support.",
          type: "error",
        });
      }
      if (error.response.status === 403) {
        setAlert({
          title: "Account already exists",
          message:
            "This account has already migrated. Please sign in normally.",
          type: "error",
        });
      }
      if (error.response.status === 406) {
        setAlert({
          title: "Account error",
          message:
            "This account may not be setup correctly. Please contact support.",
          type: "error",
        });
      }
    }

    //
  }

  function onCodeSubmit(values) {
    setLoadingAuth(true);

    //Incorrect Code
    if (String(values.code) !== String(otp)) {
      //Alert user
      setLoadingAuth(false);
      setAlert({
        title: "Incorrect Code",
        message:
          "Code entered does not match code sent in email. Please try again",
        type: "error",
      });
    }
    //Correct code
    else {
      setPassword(true);
      setLoadingAuth(false);
    }
  }

  function onPasswordSubmit(values) {
    legacySignup({ email, password: values.password, recordID });
  }

  return (
    <Layout>
      <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          <div>
            <Link href="/">
              <div className="flex justify-center cursor-pointer">
                <Image
                  src="/logo/wave-distro-logo.png"
                  alt="Wave Distribution Logo"
                  layout="intrinsic"
                  width={230}
                  height={66}
                />
              </div>
            </Link>
            <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
              Connect your legacy account
            </h2>
            <p className="mt-2 text-center text-sm text-gray-600">
              Or{" "}
              <Link href="/signup">
                <span className="font-medium text-primaryDark hover:text-primary">
                  create a new account
                </span>
              </Link>
            </p>
          </div>
          {!emailSent && (
            <LegacyEmail
              loadingAuth={loadingAuth}
              onEmailSubmit={onEmailSubmit}
            />
          )}
          {emailSent && !password && (
            <LegacyCode loadingAuth={loadingAuth} onCodeSubmit={onCodeSubmit} />
          )}
          {emailSent && password && (
            <LegacyPassword
              loadingAuth={loadingAuth}
              onPasswordSubmit={onPasswordSubmit}
            />
          )}
        </div>
      </div>
    </Layout>
  );
}
